import { getApiUrl, getAuthHeaders } from './api-client';

export async function getAdminReviews(params = {}) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return { items: [], total: 0 };
    
    const queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      }
    }

    const url = `${apiUrl}/admin/reviews${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await fetch(url, {
      cache: 'no-store',
      headers: { 'Accept': 'application/json', ...getAuthHeaders() }
    });

    if (!response.ok) return { items: [], total: 0 };
    const data = await response.json();
    return { items: data.items || [], total: data.total || 0 };
  } catch (error) {
    console.error("Error fetching admin reviews:", error);
    return { items: [], total: 0 };
  }
}

export async function getAdminReview(reviewId) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return null;
    
    const response = await fetch(`${apiUrl}/admin/reviews/${reviewId}`, {
      cache: 'no-store',
      headers: { 'Accept': 'application/json', ...getAuthHeaders() }
    });

    return response.ok ? response.json() : null;
  } catch (error) {
    console.error("Error fetching admin review:", error);
    return null;
  }
}

export async function createAdminReview(payload) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return { error: true, message: 'API URL не определен' };
    
    const response = await fetch(`${apiUrl}/admin/reviews`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });

    return response.ok ? response.json() : { error: true, message: 'Ошибка при создании' };
  } catch (error) {
    console.error("Error creating review:", error);
    return { error: true, message: error.message };
  }
}

export async function updateAdminReview(reviewId, payload) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return { error: true, message: 'API URL не определен' };
    
    const response = await fetch(`${apiUrl}/admin/reviews/${reviewId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });

    return response.ok ? response.json() : { error: true, message: 'Ошибка при обновлении' };
  } catch (error) {
    console.error("Error updating review:", error);
    return { error: true, message: error.message };
  }
}

export async function deleteAdminReview(reviewId) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return { error: true, message: 'API URL не определен' };
    
    const response = await fetch(`${apiUrl}/admin/reviews/${reviewId}`, {
      method: 'DELETE',
      headers: { 'Accept': 'application/json', ...getAuthHeaders() }
    });

    return (response.ok || response.status === 204) ? { ok: true } : { error: true, message: 'Ошибка при удалении' };
  } catch (error) {
    console.error("Error deleting review:", error);
    return { error: true, message: error.message };
  }
}
